import React from 'react';
import PropTypes from 'prop-types';
import MemberStore from '../../stores/MemberStore';
import MembersActionCreators from '../../actions/MembersActionCreators';

class MemberQuestionsBlock extends React.Component {
  state = {
    questions: MemberStore.getMemberQuestions(this.props.memberId),
  };

  componentDidMount() {
    const { memberId } = this.props;
    if (!memberId) {
      return;
    }

    MemberStore.addChangeMemberQuestionsListener(this.onChange);

    const { questions } = this.state;
    if (!questions) {
      MembersActionCreators.loadQuestions(memberId);
    }
  }

  componentWillUnmount() {
    MemberStore.removeChangeMemberQuestionsListener(this.onChange);
  }

  onChange = () => {
    this.setState({
      questions: MemberStore.getMemberQuestions(this.props.memberId),
    });
  };

  render() {
    const { questions } = this.state;
    if (!questions) {
      return (null);
    }

    const { section } = this.props;
    const showQuestions = section === 'my' ? questions.my : questions.looking;

    const categories = [];
    showQuestions.forEach((category) => {
      Object.keys(category).forEach((categoryName) => {
        const categoryQuestions = [];
        category[categoryName].forEach((question) => {
          Object.keys(question).forEach((questionName) => {
            const questionAnswers = [];
            if (Array.isArray(question[questionName])) {
              question[questionName].forEach((answer) => {
                questionAnswers.push(
                  <div key={answer}>
                    {answer}
                  </div>,
                );
              });
            } else {
              questionAnswers.push(
                <div key={question[questionName]}>
                  {question[questionName]}
                </div>,
              );
            }
            categoryQuestions.push(
              <div key={questionName} className="questionsAnswers-item questionsAnswers-row paf">
                <div className="g-b g-b--1of2">
                  {questionName}
                </div>
                <div className="g-b g-b--1of2 twsb">
                  {questionAnswers}
                </div>
              </div>,
            );
          });
        });
        categories.push(
          <div key={categoryName} className="group questionsAnswers-category">
            <div className="block-title mbs">
              {categoryName}
            </div>
            {categoryQuestions}
          </div>,
        );
      });
    });

    return (
      <div className="">
        {categories}
      </div>
    );
  }
}

MemberQuestionsBlock.propTypes = {
  memberId: PropTypes.string,
  section: PropTypes.string.isRequired,
};

MemberQuestionsBlock.defaultProps = {
  memberId: null,
};

export default MemberQuestionsBlock;
